import Moment from "moment";
export const useCreateAnnouncementValidation = initialForm => {
  const { endDate, title, startDate, content } = initialForm;

  const dateToday = new Date().toLocaleString() + "";

  const newStartDate = startDate
    ? startDate
    : Moment(dateToday).format("YYYY-MM-D");
  const endDateMessage = () => {
    if (!endDate) {
      return "This field is required.";
    }
    if (endDate && newStartDate > endDate) {
      return "End date should be later than start date.";
    }
    return null;
  };
  const titleMessage = () => {
    if (title === "" || title === null) {
      return "This field is required.";
    }

    return null;
  };
  const startDateMessage = () => {
    if (!startDate) {
      return "This field is required.";
    }
    return null;
  };

  const contentMessage = () => {
    if (JSON.stringify(content) === "" || content === null) {
      return "This field is required.";
    }

    return null;
  };

  return {
    content: contentMessage(),
    endDate: endDateMessage(),
    startDate: startDateMessage(),
    title: titleMessage()
  };
};
